export default {
  SET_BRAND_TAX (state, brand_taxes) {
    state.brand_taxes = brand_taxes
  },
  REMOVE_RECORD (state, itemId) {
    const brandTaxIndex = state.brand_taxes.findIndex((u) => u.id === itemId)
    state.brand_taxes.splice(brandTaxIndex, 1)
  }
}
